module.exports = __webpack_public_path__ + "media/images/pic/saska/hero_saska_kids-664b593580baf0e3018abd5f1715f0e9.svg";